import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Temporada26 } from "./pages/Temporada26";
import { TemporadaAgosto26 } from "./pages/TemporadaAgosto26";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Temporada26 />} />
          <Route path="/temporadaAgosto26" element={<TemporadaAgosto26 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
